<template>
  <div class="topic-city">
    <div class="topic" v-if="topics.length">
      <div class="topic-label">类别</div>
      <div class="topic-list">
        <router-link
          class="topic-item"
          :class="{ active: $route.params.topic == topTopic.englishName }"
          :to="{
            params: { topic: topTopic.englishName },
            query: { ...$route.query, offset: undefined },
          }"
        >
          不限
        </router-link>
        <router-link
          class="topic-item"
          v-for="item in topics"
          :key="item.id"
          :class="{ active: activeTopic.englishName == item.englishName }"
          :to="{ params: { topic: item.englishName }, query: { ...$route.query, offset: undefined } }"
        >
          {{ item.name }}
        </router-link>
      </div>
    </div>
    <div class="city" v-if="citys.length">
      <div class="city-label">城市</div>
      <div class="city-list">
        <router-link
          class="topic-item"
          :class="{ active: !$route.query.city }"
          :to="{ query: { ...$route.query, offset: undefined, city: undefined } }"
        >
          不限
        </router-link>
        <router-link
          class="city-item"
          v-for="city in citys"
          :key="city.id"
          :class="{ active: $route.query.city == city.id }"
          :to="{ query: { ...$route.query, offset: undefined, city: city.id } }"
        >
          {{ city.name }}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { setHtmlMeta } from '@/utils/utils';
export default {
  name: 'CateNav',
  data() {
    return {
      // 二级板块列表
      topics: [],
      // 城市列表
      citys: [],
      // 当前一级板块信息
      topTopic: {},
      // 当前二级板块信息
      topic: {},
      // 数据加载状态
      loading: false,
    };
  },
  computed: {
    // 高亮的板块
    activeTopic() {
      return (
        this.topics.find(item => item.englishName === this.$route.params.topic) ||
        this.topics.find(item => item.englishName == this.topic.englishName) ||
        {}
      );
    },
  },
  created() {
    const { topic } = this.$route.params;
    if (!topic) return;

    // 只是在当前的一级板块和二级板块之间进行切换时，不重新请求板块数据
    let current;
    if (this.topTopic.englishName == topic) {
      current = this.topTopic;
      this.$emit('topicChange', {
        top: this.topTopic,
        current,
      });
    } else if ((current = this.topics.find(t => t.englishName == topic))) {
      this.$emit('topicChange', {
        top: this.topTopic,
        current,
      });
    } else {
      this.getTopicsAndCities();
    }
  },
  methods: {
    // 获取列表和城市信息
    async getTopicsAndCities() {
      this.loading = true;
      const { data } = await this.$axios
        .post('/info/v1/get/list/mix_data1', {
          topicEngName: this.$route.params.topic,
        })
        .finally(() => {
          this.loading = false;
        });

      this.citys = data.citys || [];
      this.topics = data.topics || [];
      this.topTopic = data.topicOneInfo || {};
      this.topic = data.topicInfo || {};

      setHtmlMeta({
        title: data.topicInfo.seoTitle,
        description: data.topicInfo.seoDescription,
        keywords: data.topicInfo.seoKeyword,
      });

      // 发送一级板块信息和当前板块信息
      this.$emit('topicChange', {
        top: this.topTopic,
        current: this.topic,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.topic-city {
  margin-top: 30px;
  margin-bottom: 18px;
}
.topic,
.city {
  display: flex;
}
.topic-label,
.city-label {
  width: 60px;
  font-size: 14px;
  color: var(--text-color-6);
  line-height: 26px;
}
.topic-list,
.city-list {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
}
.topic-item,
.city-item {
  line-height: 26px;
  font-size: 14px;
  padding: 0 10px;
  border-radius: 4px;
  margin-bottom: 12px;
  &.active {
    color: var(--primary-color);
    background: var(--primary-color-lightest);
  }
  &:hover {
    color: var(--primary-color);
  }
}
</style>
